<template>
	<div>
		<right-panel :datas="connects" @onClose="onCloseForm" ref="right-panel">
			<div slot="header">
				<translate>Set Cluster</translate>
			</div>
			<div slot="content" class="set-cluster-content">
				<el-form ref="setClusterForm" :model="clusterSetForm" :rules="rules" label-width="140px">
					<el-form-item :label="attrText.name" prop="name">
						<el-input v-model.trim="clusterSetForm.name"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.ip" prop="agent_host_alias">
						<el-input v-model.trim="clusterSetForm.agent_host_alias"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.code">
						<el-radio v-model="clusterSetForm.codeSet" label="1"><translate>Default</translate></el-radio>
						<el-radio v-model="clusterSetForm.codeSet" label="2"><translate>Customize</translate></el-radio>
					</el-form-item>
					<el-form-item label=" " prop="time" v-if="clusterSetForm.codeSet === '2'">
						<el-input v-model.number="clusterSetForm.time" class="set-input"></el-input>
						<el-select v-model="clusterSetForm.timeType" placeholder="请选择" class="set-select">
							<el-option v-for="item in timeArr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<div class="set-note">
						<translate>Log in resource need to generate a code, every code has a effective period,This term set the maximum effective period that user can set.</translate>
					</div>
					<el-form-item :label="attrText.ConnectMap" prop="" style="margin-top: 20px; margin-bottom: 0">
						<el-switch v-model="clusterSetForm.is_open_map" on-text="" off-text=""></el-switch>
					</el-form-item>
					<p class="set-note">
						<translate>Note: After enabling the service connection mapping function, the IP and port displayed during actual connection will be subject to the current mapping rules.</translate>
					</p>
					<el-table :data="clusterSetForm.port_map_info">
						<el-table-column prop="ip_name" :label="attrText.ipName"> </el-table-column>
						<el-table-column prop="origin_port" :label="attrText.originPort"> </el-table-column>
						<el-table-column prop="map_port" :label="attrText.mapPort">
							<template scope="scope">
								<el-input v-model.number="scope.row.map_port" type="number" @change="changeMapPort(scope.row)" />
							</template>
						</el-table-column>
					</el-table>
				</el-form>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="onSubmit()">
					<translate>Submit</translate>
				</el-button>
				<el-button @click="onCloseForm()">
					<translate>Cancel</translate>
				</el-button>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
export default {
	name: 'SetCluster',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		const checkTime = (rule, value, callback) => {
			if (value) {
				let maxTunnelExpireTime
				if (this.clusterSetForm.timeType === 'minute') {
					maxTunnelExpireTime = this.clusterSetForm.time * 60
				} else if (this.clusterSetForm.timeType === 'hour') {
					maxTunnelExpireTime = this.clusterSetForm.time * 60 * 60
				} else if (this.clusterSetForm.timeType === 'day') {
					maxTunnelExpireTime = this.clusterSetForm.time * 60 * 60 * 24
				}
				if (maxTunnelExpireTime > 60 * 60 * 24 * 365) {
					callback(new Error(this.$gettext('Effective time cannot exceed 1 year')))
				} else if (maxTunnelExpireTime < 60 * 30) {
					callback(new Error(this.$gettext('In order to ensure the availability of the code, the maximum effective time cannot be less than 30 minutes')))
				} else {
					this.clusterSetForm.max_tunnel_expire_time = maxTunnelExpireTime
					callback()
				}
			} else {
				callback(new Error(this.$gettext('In order to ensure the availability of the code, the maximum effective time cannot be less than 30 minutes')))
			}
		}
		return {
			connects: null,
			timeArr: [
				{
					value: 'minute',
					label: this.$gettext('minute'),
				},
				{
					value: 'hour',
					label: this.$gettext('hour'),
				},
				{
					value: 'day',
					label: this.$gettext('day'),
				},
			],
			clusterSetForm: {
				name: '',
				agent_host_alias: '',
				codeSet: '1',
				timeType: 'minute',
				time: 0,
				is_open_map: false,
				port_map_info: [],
			},
			rules: {
				name: [
					{
						required: true,
						message: this.$gettext('Please input the cluster name'),
						trigger: 'blur',
					},
					{ max: 50, message: this.$gettext('length is within 50 characters'), trigger: 'change' },
				],
				time: [
					{ required: true, type: 'number', message: this.$gettext('Please enter the numeric type'), trigger: 'blur' },
					{ validator: checkTime, trigger: 'blur' },
				],
			},
			port_map_info: [],
		}
	},
	computed: {
		attrText() {
			return this.initAttrText()
		},
	},
	methods: {
		initAttrText() {
			return {
				name: this.$gettext('Cluster Name :'),
				ip: this.$gettext('Cluster IP :'),
				code: this.$gettext('The maximum effective time of code :'),
				ipName: this.$gettext('IP Name'),
				originPort: this.$gettext('Origin Port'),
				mapPort: this.$gettext('Map Port'),
				ConnectMap: this.$gettext('Service Port Mapping'),
			}
		},
		timeLongChange(time) {
			let _time
			if (time <= 3600) {
				this.clusterSetForm.timeType = 'minute'
				_time = time / 60
			} else if (time > 3600 && time <= 3600 * 24) {
				this.clusterSetForm.timeType = 'hour'
				_time = (Math.floor(time / 3600) + (time % 3600) / 3600).toFixed(2)
			} else if (time > 3600 * 24) {
				this.clusterSetForm.timeType = 'day'
				_time = (Math.floor(time / 86400) + (time % 86400) / 86400).toFixed(2)
			}
			this.clusterSetForm.time = parseFloat(_time)
			console.log(this.clusterSetForm.time, typeof this.clusterSetForm.time)
		},
		changeMapPort(row) {
			if (row.map_port.toString().includes('.')) {
				row.map_port = parseInt(row.map_port)
			}
			if (row.map_port < 1) {
				row.map_port = 1
			} else if (row.map_port > 65535) {
				row.map_port = 65535
			}
		},
		hasPorts(arr) {
			const seenPorts = new Set()
			for (const item of arr) {
				if (seenPorts.has(item.map_port)) {
					return false // 找到重复的 map_port
				}
				seenPorts.add(item.map_port)
			}

			return true // 所有 map_port 都是唯一的
		},
		onCloseForm() {
			this.clusterSetForm = {
				name: '',
				agent_host_alias: '',
				codeSet: '1',
				timeType: 'minute',
				time: 0,
			}
			this.connects = null
			this.$emit('onClosePanel')
		},
		onSubmit() {
			this.$refs['setClusterForm'].validate((valid) => {
				if (valid) {
					if (!this.hasPorts(this.clusterSetForm.port_map_info)) {
						this.$notify({
							type: 'error',
							message: this.$gettext('The port mapping rules cannot have duplicate ports'),
						})
						return
					}
					let data = {
						is_open_map: this.clusterSetForm.is_open_map,
						port_map_info: this.clusterSetForm.port_map_info,
					}
					if (this.clusterSetForm.name !== this.connects.info.name) {
						data.name = this.clusterSetForm.name
					}
					if (this.clusterSetForm.agent_host_alias !== this.connects.info.agent.host) {
						data.agent_host_alias = this.clusterSetForm.agent_host_alias
					}
					if (this.clusterSetForm.codeSet === '1') {
						data.max_tunnel_expire_time = 0
					}
					if (this.clusterSetForm.codeSet === '2') {
						data.max_tunnel_expire_time = this.clusterSetForm.max_tunnel_expire_time
					}
					let params = {
						id: this.connects.info.id,
						data: data,
					}
					this.$store.dispatch(STORE_CONST.CLUSTER.CHANGE, params).then(() => {
						this.$notify({
							type: 'success',
							message: this.$gettext('Change successful'),
						})
						this.$emit('callback')
						this.onCloseForm()
					})
				}
			})
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
				this.clusterSetForm.name = this.connects.info.name
				this.clusterSetForm.agent_host_alias = this.connects.info.agent.host
				this.clusterSetForm.is_open_map = this.connects.info.is_open_map
				this.connects.info.port_map_info.forEach((item) => {
					const addItem = {
						ip_name: item.ip_name,
						origin_port: item.origin_port,
						map_port: item.map_port,
					}
					this.clusterSetForm.port_map_info.push(addItem)
				})
				if (this.connects.info.max_tunnel_expire_time > 0) {
					this.clusterSetForm.codeSet = '2'
					this.timeLongChange(this.connects.info.max_tunnel_expire_time)
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.set-cluster-content {
	padding: 10px 30px 10px 10px;
	.set-note {
		padding: 10px 30px;
	}
	.set-input {
		width: 30%;
	}
	.set-select {
		width: 25%;
		margin-left: 15px;
	}
}
</style>



// WEBPACK FOOTER //
// cluster-set.vue?201fdbcb